const Navigate = {
  FindOperationsByCurrent(structure, current){
    let operationFound = []
    let operations = structure["Operações"]

    Object.keys(operations).forEach(index => {
      if (operations[index].Entrada && operations[index].Entrada.includes(current))
        operationFound.push(index);

      if (operations[index].Saida && operations[index].Saida.includes(current))
        operationFound.push(index);
    });

    return operationFound
  },
}

export default Navigate